import { render, staticRenderFns } from "./MainNavigationMenu.vue?vue&type=template&id=6113a5ac&scoped=true&"
import script from "./MainNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./MainNavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationMenu.vue?vue&type=style&index=0&id=6113a5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113a5ac",
  null
  
)

export default component.exports